import {
  CREATE_INTERVAL_SUCCESS,
  FETCH_INTERVAL_SUCCESS,
  GET_INTERVAL_SUCCESS,
  SAVE_INTERVAL_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_INTERVAL_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_INTERVAL_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_INTERVAL_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_INTERVAL_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
